import { render, staticRenderFns } from "./StorageOrders.vue?vue&type=template&id=1c459a3c&scoped=true&"
import script from "./StorageOrders.vue?vue&type=script&lang=js&"
export * from "./StorageOrders.vue?vue&type=script&lang=js&"
import style0 from "./StorageOrders.vue?vue&type=style&index=0&id=1c459a3c&lang=less&scoped=true&"
import style1 from "./StorageOrders.vue?vue&type=style&index=1&id=1c459a3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c459a3c",
  null
  
)

export default component.exports